<template>
<div class="search">
  <div class="search-input">
      <input
          type="text"
          placeholder="品牌/系列"
          ref="searchinput"
          v-model="searchvalue"
          @keyup.enter="searchfor"
        /> <button class="searchbtn" @click="searchfor">搜索</button>
        <div v-show="false">
          <input type="text" id="searchtext" value="" />
          <button @click="sbtn" id="searchbtn">点击</button>
        </div>

  </div>
    <el-dialog
        title="搜索结果"
        :visible.sync="dialogVisible"
        width="70%"
        custom-class="search-content"
      >
        <div class="srcon">
          <div class="item" v-for="(item, i) in allsearchdata" :key="i">
            <div class="seartit" @click="changfid(item)">
              {{ item.factoryname }}
            </div>
            <div
              class="searopt"
              v-for="(itemdata, j) in item.data"
              :key="j"
              @click="changsid(item, itemdata)"
              :title="itemdata.seriesname"
            >
              {{ itemdata.seriesname }}
            </div>
          </div>
          <div v-if="allsearchdata.length == 0">暂无匹配数据哦！</div>
        </div>
      </el-dialog>

  </div>
</template>

<script>
import { search } from "../network/home";

export default {
  data() {
    return {
      searchvalue:"" ,
       dialogVisible: false,
      allsearchdata: [] /* 全局搜索接口返回数据 */,
 
    };
  },

  watch: {
  },

  methods: {
    /* 搜索请求接口 */
  /* A、全局搜索逻辑 */
    /* 请求接口 */
    searchfor() {
      if (this.searchvalue != "") {
        this.dialogVisible = true;
        let opt_data = {
          inputstr: this.searchvalue,
        };
        search(opt_data).then((res) => {
          // console.log(res);
          this.allsearchdata = res.data;
          // console.log(res.data);
        });
      } else {
        this.$refs.searchinput.focus();
        this.$notify({
          message: "请输入搜索内容哦!",
          duration: 1800,
          type: "warning",
          offset: 50,
        });
      }
    },
       /* 针对ERP点击搜索 */
    sbtn() {
      this.searchvalue = document.getElementById("searchtext").value;
      this.searchfor();
    },


    /* 点击分别获取系列id和品牌id */
    changfid(data) {
     console.log(data);
      if (data.data.length == 0) {
         this.dialogVisible = false;

      //  this.$refs.popoverser.showPopper = false; //隐藏系列弹出框
     //  console.log(fid, sid, fname);
        this.$store.commit("fid", data.factoryid);
        this.$store.commit("fname",data.fname);
        this.$store.commit("fsortname",data.fsortname);


       // this.$store.commit("sid", sid);
      }
    },

    changsid(item, data) {
      // console.log(item);
      // console.log(data);
       this.dialogVisible = false;
     // this.$refs.popoverser.showPopper = false; //隐藏系列弹出框
    this.$store.commit("fid",item.factoryid);
        this.$store.commit("fname",item.fname);
     this.$store.commit("sid", data.SeriesId);
        this.$store.commit("fsortname",item.fsortname);


    },
  },
};
</script>
/* 全局搜索框样式 */
<style scoped lang="less">
@import "../assets/less/search";
</style>
<style lang="less">
@import "../assets/less/searchd";
</style>

<style lang="less">
.search-popper {
  border-radius: 0 !important;
  box-sizing: border-box;
}
#searchtext {
  width: 70%;
  height: 40px;
}
</style>
